export const TABLE_WRAPPER = "overflow-x-auto rounded-[3px] border border-zinc-200";
export const TABLE = "w-full text-sm";
export const THEAD = "bg-zinc-50 text-left text-zinc-500";
export const TH = "whitespace-nowrap px-4 py-2.5 font-medium";
export const TH_NUMBER = `${TH} text-right`;
export const TBODY = "divide-y divide-zinc-200 text-zinc-700";
export const TD = "px-4 py-2.5";
export const TD_NUMBER = `${TD} whitespace-nowrap text-right tabular-nums`;
